import { create } from "zustand";
import api from "../../../../api";
import { usePurchaseOrders } from "../../usePurchaseOrders";
import { showToast } from "Components/Toast";

// Drives the "import quotation prices" preview. Opened after a vendor's
// quotation .xlsx is uploaded: parses it, shows matched/unmatched lines, then
// (on confirm) writes the matched totals into that vendor's price column.
export let useImportPricesPreviewModal = create((set, get) => ({
  display: false,
  loading: false,
  saving: false,
  vendor: null, // { vendorIndex, vendorId, vendorName, currency }
  result: null, // { matched, unmatched, totalLines, headerRow }

  // Fetch + parse the uploaded quotation, then open the preview.
  startImport: async ({ purchaseOrderId, vendor, url }) => {
    set({ display: true, loading: true, result: null, vendor });
    const result = await api.purchaseOrder.parseQuotation(
      purchaseOrderId,
      url,
      vendor.vendorIndex,
      vendor.vendorId,
    );
    if (!result || !result.ok) {
      set({ display: false, loading: false });
      return;
    }
    set({ loading: false, result });
  },

  // Write the matched line totals into the vendor's price column.
  confirm: async () => {
    const { vendor, result } = get();
    if (!vendor || !result?.matched?.length) {
      set({ display: false });
      return;
    }
    set({ saving: true });
    const prices = result.matched.map((m) => ({
      itemId: m.itemId,
      price: String(m.price),
      currency: vendor.currency || "USD",
    }));
    const ok = await usePurchaseOrders
      .getState()
      .saveVendorItemPrices(vendor.vendorIndex, vendor.vendorId, prices);
    set({ saving: false });
    if (ok) {
      showToast("s", `Imported ${prices.length} prices for ${vendor.vendorName}`);
      set({ display: false, result: null, vendor: null });
    }
  },

  closeModal: () =>
    set({ display: false, loading: false, saving: false, result: null, vendor: null }),
}));
